<template>
  <tr :class="getClass">
    <td v-for="(header, index) in headers" :key="index" :class="['custom-padding', headerClass(header)]">
      <slot :item="item" :name="columnName(header)">
        <div :style="getAlignment(header)">
          {{ getNonSlotValue(item, header) }}
        </div>
      </slot>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    itemClass: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    headers: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    getClass() {
      return this.itemClass
    }
  },
  methods: {
    columnName(header) {
      return `item.${header.value}`
    },
    getAlignment(header) {
      const align = header.align ? header.align : 'right'
      return `text-align: ${align}`
    },
    getNonSlotValue(item, header) {
      const val = item[header.value]

      if (val) {
        return val
      }

      return ''
    },
    headerClass(header) {
      return header.class ? header.class : ''
    }
  }
}
</script>

<style scoped>
.custom-padding {
  padding: 0px 0px; /* Adjust as needed */
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
